/**
 * URL della pagina pubblica di prodotto raggiunta dal QR sull'etichetta.
 *
 * L'URL finisce stampato su etichette fisiche, quindi NON può dipendere da
 * window.location: in sviluppo produrrebbe etichette con dentro localhost:5173.
 * VITE_PUBLIC_APP_URL va valorizzata negli ambienti in cui si stampa davvero;
 * il fallback su window.location.origin serve solo a non rompere l'anteprima.
 */
function baseUrl(): string {
  return (import.meta.env.VITE_PUBLIC_APP_URL as string | undefined)?.replace(/\/+$/, '')
    || window.location.origin;
}

export function buildProductPublicUrl(token: string): string {
  return `${baseUrl()}/prodotto/${token}`;
}

/**
 * Pagina di tracciabilità del lotto (`/tracciabilita/:lotId`), destinazione del
 * QR sulle etichette di magazzino. Non è pubblica: legge `product_lots` con la
 * chiave anon, che le migration di lockdown hanno revocato — la apre chi è
 * autenticato, che è il senso di `qr_access: 'authenticated'`. Per un QR
 * destinato al cliente finale si usa `buildProductPublicUrl`.
 */
export function buildLotTraceabilityUrl(lotId: string): string {
  return `${baseUrl()}/tracciabilita/${lotId}`;
}
